import {KTCard} from '../../../../../_metronic/helpers/components/KTCard'
import {HazardManagementListHeader} from './components/header/HazardManagementListHeader'
import {ListViewProvider, useListView} from './core/ListViewProvider'
import {QueryRequestProvider} from './core/QueryRequestProvider'
import {QueryResponseProvider} from './core/QueryResponseProvider'
import {ApprovedWorkAuthorizationTable} from './table/ApprovedWorkAuthorizationTable'

const ApprovedWorkAuthorizationList = () => {
  return (
    <>
      <KTCard>
        <HazardManagementListHeader />
        <ApprovedWorkAuthorizationTable />
      </KTCard>
    </>
  )
}

const ApprovedWorkAuthorizationListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListViewProvider>
        <ApprovedWorkAuthorizationList />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export {ApprovedWorkAuthorizationListWrapper}
